/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1MutualFundsTaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_TASK_STATE_ENTITY_NAME = 'ixc.mutualfunds.v1.MutualFundsTask';
export const ixcMutualfundsV1MutualFundsTaskStateEntity = new schema.Entity<IxcMutualfundsV1MutualFundsTaskState>(IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'mutualFundsTaskId' });

